import React, { useCallback, useEffect, useState } from 'react'
import Header from "./Components/header";
import About from './Components/about';
import Feedback from "./Components/feedback"
import Registration from './Components/registration';
import {AuthContext} from "./contextAPI";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import LoadingSpinner from "./Components/bounce";
import styles from "./app.module.css";
import { notify } from './Components/toast';

const App = () => {

  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [authenticatedUser, setAuthenticatedUser] = useState();

  useEffect(()=>{
    const loadingHandler = async() => {
      setIsLoading(true)
      const timer = setTimeout(() => setIsLoading(false), 1500);
      return () => clearTimeout(timer);
    }

    loadingHandler();


  },[])

  const login = useCallback((user) => {
    if(!user.status === "success"){
      setIsLoggedIn(false);
      return;
    }
    const {response, token} = user.data;
    setIsLoggedIn(true)
    setAuthenticatedUser({data: response, token: token})
  }, [])

  const logout = useCallback(() => {
    setAuthenticatedUser(null);
    setIsLoggedIn(false)
  }, [])

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout, authenticatedUser }}>
      {isLoading && <div className={styles.loading_container}>
        <LoadingSpinner />
      </div>}
      <ToastContainer />
      <Header />
      <About/>
      <Feedback />
      <Registration />
    </AuthContext.Provider>
  )
}

export default App